import React, { useCallback, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Tooltip,
} from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import { useStyles } from "./style";
import { useNavigate } from "react-router-dom";
import Pen from "../../../assets/images/CourseManagement/pen.svg";
import CustomExpandMore from "../../../common/CustomExpandMore";
import { useExamAndGradeStore } from "../../../Hooks/examAndGrade";
import useCourse from "../../../Hooks/course";
import useSemester from "../../../Hooks/semester";
import usePagination from "../../../common/usePagination";
import CustomPagination from "../../../common/Pagination";
import * as Yup from "yup";
import { months } from "../../../Utils/weekdays";
import useAuthStore from "../../../Hooks/auth";
import Loader from "../../../common/Loader";
import moment from "moment";
import { niceBytes } from "../../../Utils/sizeConverter";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { DateRangePicker } from "rsuite";

const row = [
  {
    id: 1,
    fileName: "mch",
    date: "17/01/2023",
    size: "5KB",
  },
];

function getStudentColumn(studetnMarks) {
  let column =
    studetnMarks &&
    studetnMarks.map((_el) => ({
      id: _el.subjectName,
      subId: _el.subjectId,
      label: _el.subjectName,
      align: "center",
      hasSubject: true,
    }));

  if (column) {
    return [
      {
        id: "regNumber",
        label: "Reg Number",
        align: "center",
      },
      {
        id: "studentName",
        label: "Student Name",
        align: "center",
      },
      ...column,
      // {
      //   id: "edit",
      //   label: "Edit",
      //   align: "center",
      // },
    ];
  }
}

const columns = [
  {
    id: "name",
    label: "File Name",
    align: "center",
    sortby: true,
  },
  {
    id: "lastModifiedDate",
    label: "Date",
    align: "center",
    sortby: true,
  },
  {
    id: "size",
    label: "Size",
    align: "center",
    sortby: true,
  },
];

const getMarksFromData = (subId, data) => {
  try {
    console.log("getMarksFromData", subId, data);
    return data.find((el) => el.subjectId === subId).marks;
  } catch (error) {
    console.error("getMarksFromData", error);
  }
  return "-";
};

const examAndGradeSchema = Yup.object().shape({
  idDepartment: Yup.string().required("* Please select depatment"),
  year: Yup.number()
    .min(1, "Year must be more than 1")
    .max(7, "Year must be less than 7")
    .required("* Please enter year"),
  idSemester: Yup.string().required("* Please select semester"),
});

const ExamManagement = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [PerPage, setPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const { userId } = useAuthStore();
  const {
    uploadExamMarksAction,
    downloadMarksTemplateAction,
    fileUrl,
    resetUrlAction,
    studentMarksData,
    getStudentSubjectMarksAction,
    getStudentDetailsAction,
    loading,
    recentFiles,
    setHistorySearchAction,
    historySearch,
  } = useExamAndGradeStore();
  const examManagementRef = React.useRef();

  const { getDepartmentAction, departmentData } = useCourse();
  const { getSemesterAction, semesterData } = useSemester();
  const { institutionId } = useAuthStore();

  const handlePage = (e) => {
    setPerPage(e.target.value);
  };

  const count = Math.ceil(studentMarksData?.totalNo?.totalNoORecords / PerPage);
  const _DATA = usePagination(studentMarksData?.studentSubjectMarks, PerPage);

  const handleChange = useCallback(
    (e, p) => {
      setPage(p);
      setOffset(p * PerPage - PerPage);
      _DATA.jump(p);
    },
    [PerPage, page]
  );
  React.useEffect(() => {
    setTimeout(() => {
      if (examManagementRef.current) {
        getStudentSubjectMarksAction({
          ...historySearch,
          limit: PerPage,
          offset: offset,
          institutionId,
        });
      }
    }, 100);
  }, [PerPage, page]);

  React.useEffect(() => {
    getDepartmentAction({
      department: {
        institutionId,
      },
    });
    getSemesterAction({ limit: 50, offSet: 0, institutionId });
  }, []);

  const handleDownloadFile = async (dataurl, filename) => {
    var arr = dataurl?.split(","),
      bstr = window.atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    let newBlob = new Blob([u8arr]);

    const blobUrl = URL.createObjectURL(newBlob);
    // Create a link element
    const link = document.createElement("a");

    // Set link's href to point to the Blob URL
    link.href = blobUrl;
    link.download = filename;

    // Append link to the body
    document.body.appendChild(link);
    // Dispatch click event on the link
    // This is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );

    // Remove link from body
    document.body.removeChild(link);
    resetUrlAction();
  };

  const handleFile = (e) => {
    // get the files
    let file = e.target.files[0];
    const { target = {} } = e || {};

    // Make new FileReader
    let reader = new FileReader();

    // Convert the file to base64 text
    reader.readAsDataURL(file);
    reader.onload = () => {
      uploadExamMarksAction({
        data: {
          idFaculty: userId,
          base64String: reader.result.substr(reader.result.indexOf(",") + 1),
        },
        file,
      });
      target.value = "";
    };
  };

  const initvalues = historySearch;

  return (
    <>
      {loading && <Loader />}

      <Stack className={classes.exam}>
        <div>
          <Stack
            sx={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: "80%",
            }}
          >
            <Stack>
              <Paper
                sx={{
                  width: "250px",
                  display: "flex",
                  justifyContent: "space-between",
                  py: 2,
                  px: 4,
                  borderRadius: "23px",
                  background: "#F5F5FA !important",
                }}
                elevation={2}
              >
                <Stack
                  sx={{
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "20px",
                      padding: 0,
                      margin: 0,
                      fontWeight: 900,
                    }}
                  >
                    Upload Marks
                  </p>
                  <Tooltip
                    title="Upload"
                    arrow
                    placement="top-start"
                    sx={{ fontFamily: "inter" }}
                  >
                    <Button component="label" className={classes.upload_btn}>
                      <ArrowUpwardIcon
                        style={{ cursor: "pointer", color: "#D9ECFF" }}
                      />
                      <input
                        type="file"
                        hidden
                        onChange={(e) => handleFile(e)}
                      />
                    </Button>
                  </Tooltip>
                </Stack>
              </Paper>
            </Stack>
          </Stack>
        </div>
        <div>
          <Stack>
            <Box sx={{ width: "70%" }} className={classes.cardGaps}>
              <Paper
                sx={{
                  width: "100%",
                  p: 4,
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Typography sx={{ py: 2 }} className={classes.title}>
                  Uploaded Files
                </Typography>
                <Grid container>
                  <Grid item lg={12} sm={12}>
                    <Stack>
                      <TableContainer>
                        <Table
                          aria-label="sticky table"
                          className={classes.root}
                          style={{ padding: 0 }}
                        >
                          <TableHead>
                            <TableRow classes={{ root: classes.thead }}>
                              {columns.map((column) => (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  style={{
                                    minWidth: column.minWidth,
                                    paddingLeft: column.paddingLeft,
                                  }}
                                  classes={{ root: classes.columnData }}
                                >
                                  {column.label}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>

                          <TableBody classes={{ root: classes.tBody }}>
                            {recentFiles?.length > 0 ? (
                              recentFiles.map((_el, index) => (
                                <TableRow
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={index}
                                >
                                  {columns.map((column) => {
                                    return (
                                      <TableCell
                                        key={column.id}
                                        align={column.align}
                                      >
                                        {column.id === "name"
                                          ? _el.name
                                          : column.id === "lastModifiedDate"
                                          ? moment(_el.lastModifiedDate).format(
                                              "DD-MM-YYYY"
                                            )
                                          : column.id === "size"
                                          ? niceBytes(_el.size)
                                          : ""}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell
                                  colSpan={6}
                                  sx={{ borderBottom: "none" }}
                                >
                                  <Stack
                                    sx={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    No Data
                                  </Stack>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Stack>
                  </Grid>
                </Grid>
              </Paper>
            </Box>
          </Stack>
        </div>

        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            display: "flex",
            my: 2,
            gap: 2,
          }}
        >
          <Formik
            innerRef={examManagementRef}
            initialValues={initvalues}
            validateOnBlur={true}
            validationSchema={examAndGradeSchema}
            validateOnChange={true}
            onSubmit={(values) => {
              const { offset, limit, months, ...downloadParmas } = values;
              downloadMarksTemplateAction({
                ...downloadParmas,
                month: months,
                institutionId,
              });
              getStudentSubjectMarksAction({
                ...values,
                limit: PerPage,
                offset: offset,
                institutionId,
              });

              setHistorySearchAction({
                ...values,
                limit: PerPage,
                offset: offset,
                institutionId,
              });
            }}
          >
            {(formik) => {
              const {
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                values,
              } = formik;

              return (
                <>
                  <form
                    onSubmit={handleSubmit}
                    className={classes.attendanceForm}
                  >
                    <Grid container>
                      <Grid item lg={12} sx={{ display: "flex", py: 2 }}>
                        <Stack
                          sx={{
                            flexDirection: "row",
                            alignItems: "center",
                            display: "flex",
                            gap: 2,
                          }}
                        >
                          <Stack>
                            <Typography
                              className={classes.textgap}
                              sx={{ mx: 1 }}
                            >
                              Year
                            </Typography>
                          </Stack>
                          <Stack>
                            <TextField
                              id="year"
                              type="number"
                              name="year"
                              placeholder="Select Year"
                              sx={{
                                width: 251,
                              }}
                              className={
                                errors.year && touched.year
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.year}
                            />

                            <ErrorMessage
                              name="year"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          sx={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            display: "flex",
                            gap: 2,
                          }}
                        >
                          <Stack>
                            <Typography
                              className={classes.textgap}
                              sx={{ mx: 1 }}
                            >
                              Semester
                            </Typography>
                          </Stack>
                          <Stack>
                            <Select
                              id="idSemester"
                              name="idSemester"
                              displayEmpty
                              onChange={handleChange}
                              IconComponent={CustomExpandMore}
                              sx={{
                                width: 252,
                              }}
                              value={values.idSemester}
                            >
                              <MenuItem disabled value="">
                                <span>Select Semester</span>
                              </MenuItem>
                              {semesterData &&
                                semesterData?.map((_el, index) => (
                                  <MenuItem value={_el.id} key={index}>
                                    {_el.name}
                                  </MenuItem>
                                ))}
                            </Select>
                            <ErrorMessage
                              name="idSemester"
                              component="span"
                              className={[
                                classes.error,
                                classes.selectError,
                              ].join(" ")}
                            />
                          </Stack>
                        </Stack>
                      </Grid>
                      <Grid item lg={12} sx={{ display: "flex" }}>
                        <Stack
                          sx={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            display: "flex",
                            gap: 2,
                          }}
                        >
                          <Stack>
                            <Typography
                              className={classes.textgap}
                              sx={{ mx: 1 }}
                            >
                              Dept
                            </Typography>
                          </Stack>
                          <Stack>
                            <Select
                              id="idDepartment"
                              name="idDepartment"
                              placeholder="Choose idDepartment"
                              onChange={handleChange}
                              IconComponent={CustomExpandMore}
                              sx={{
                                width: 252,
                              }}
                              value={values.idDepartment}
                              displayEmpty
                            >
                              <MenuItem disabled value="">
                                <span>Select Department</span>
                              </MenuItem>
                              {departmentData &&
                                departmentData.map((_el, index) => (
                                  <MenuItem value={_el.id} key={index}>
                                    {_el.name}
                                  </MenuItem>
                                ))}
                            </Select>
                            <ErrorMessage
                              name="idDepartment"
                              component="span"
                              className={[
                                classes.error,
                                classes.selectError,
                              ].join(" ")}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          sx={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            display: "flex",
                            gap: 2,
                          }}
                        >
                          <Stack>
                            <Typography
                              className={classes.textgap}
                              sx={{ mx: 3 }}
                            >
                              Date
                            </Typography>
                          </Stack>
                          <Stack>
                            <TextField
                              id="months"
                              type="date"
                              name="months"
                              placeholder="Choose month"
                              onChange={handleChange}
                              IconComponent={CustomExpandMore}
                              sx={{
                                width: 252,
                              }}
                              value={values.months}
                              displayEmpty
                            >
                              <MenuItem disabled value="">
                                <span>Select Month</span>
                              </MenuItem>
                              {/* {months &&
                                months.map((_el, index) => (
                                  <MenuItem value={_el} key={index}>
                                    {_el}
                                  </MenuItem>
                                ))} */}
                            </TextField>
                            <ErrorMessage
                              name="months"
                              component="span"
                              className={[
                                classes.error,
                                classes.selectError,
                              ].join(" ")}
                            />
                          </Stack>
                        </Stack>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          p: 2,
                          gap: 3,
                        }}
                      >
                        <Stack>
                          <Button
                            type="submit"
                            sx={{
                              px: 1,
                              py: 1,
                              borderRadius: "50px",
                            }}
                            className={classes.search_btn}
                          >
                            Search
                          </Button>
                        </Stack>
                        <Stack>
                          <Button
                            type="button"
                            sx={{
                              px: 1,
                              py: 1,
                              borderRadius: "50px",
                              padding: "2rm",
                            }}
                            disabled={!fileUrl?.length || fileUrl === undefined}
                            className={classes.search_btn}
                            onClick={() =>
                              handleDownloadFile(
                                "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
                                  fileUrl,
                                `year${values.year}-semester${values.idSemester}.xlsx`
                              )
                            }
                          >
                            Download
                          </Button>
                        </Stack>
                      </Grid>
                    </Grid>
                  </form>
                </>
              );
            }}
          </Formik>
        </Stack>

        <div>
          <Stack>
            <Box sx={{ width: "70%" }} className={classes.cardGaps}>
              <Paper
                sx={{
                  width: "100%",
                  p: 4,
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Typography sx={{ py: 2 }} className={classes.title}>
                  Results
                </Typography>
                <Grid container>
                  <Grid item lg={12} sm={12}>
                    <Stack>
                      <TableContainer sx={{ maxHeight: 440 }}>
                        <Table
                          aria-label="sticky table"
                          className={classes.root}
                          style={{ padding: 0 }}
                          stickyHeader
                        >
                          <TableHead>
                            <TableRow classes={{ root: classes.thead }}>
                              {getStudentColumn(
                                studentMarksData?.studentSubjectMarks?.[0]
                                  ?.studentMarks
                              )?.map((column) => (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  style={{
                                    minWidth: column.minWidth,
                                    paddingLeft: column.paddingLeft,
                                  }}
                                  classes={{ root: classes.columnData }}
                                >
                                  {column.label}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>

                          <TableBody classes={{ root: classes.tBody }}>
                            {studentMarksData?.studentSubjectMarks?.length >
                            0 ? (
                              studentMarksData?.studentSubjectMarks?.map(
                                (_el, index) => (
                                  <TableRow
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={index}
                                  >
                                    {getStudentColumn(
                                      studentMarksData?.studentSubjectMarks?.[0]
                                        ?.studentMarks
                                    )?.map((column, index) => {
                                      console.log("column", index, _el);
                                      return (
                                        <TableCell
                                          key={column.id}
                                          align={column.align}
                                        >
                                          {column.id === "regNumber" ? (
                                            _el.regNumber
                                          ) : column.id === "studentName" ? (
                                            _el.studentName
                                          ) : column.id === "edit" ? (
                                            <Stack
                                              sx={{
                                                alignItems: "center",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => {
                                                getStudentDetailsAction({
                                                  idStudent: _el.studentId,
                                                });
                                                navigate("/updateMark");
                                              }}
                                            >
                                              <img src={Pen} alt="pen" />
                                            </Stack>
                                          ) : (
                                            column.hasSubject && (
                                              <>
                                                {getMarksFromData(
                                                  column.subId,
                                                  _el.studentMarks
                                                )}
                                              </>
                                            )
                                          )}
                                        </TableCell>
                                      );
                                    })}
                                  </TableRow>
                                )
                              )
                            ) : (
                              <TableRow>
                                <TableCell
                                  colSpan={5}
                                  sx={{ borderBottom: "none" }}
                                >
                                  <Stack
                                    sx={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    No Data
                                  </Stack>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {studentMarksData?.totalNo?.totalNoORecords > 10 && (
                        <CustomPagination
                          count={count}
                          page={page}
                          onPageChange={handleChange}
                          handlePage={handlePage}
                          perPage={PerPage}
                        />
                      )}
                    </Stack>
                  </Grid>
                </Grid>
              </Paper>
            </Box>
          </Stack>
        </div>
      </Stack>
    </>
  );
};

export default ExamManagement;
